'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function BJFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-mzsqzgps3", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-mzsqzgps3)" }, /* @__PURE__ */ React.createElement("path", { fill: "#dd2c2b", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M0 0h32v14H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#5eaa22", d: "M0 0h14v24H0z" })))
  );
}

export { BJFlag };
//# sourceMappingURL=BJ.mjs.map
